export const externalComplianceReferenceFields = `fragment externalComplianceReferenceFields on ExternalComplianceReference {
  sku
  skuComplianceVersion
  snapshotId
  source
}`;
